import type { AllRouteEndpoints } from "../routeTypes";

export const postDecisioningStudioAgentsAppGroupIdDsaIdWorkflowsCacheKeys: AllRouteEndpoints[] = [
  "/engagement/get_changelogs",
];
